module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightStep-9483bdab49b7c67a4eb26045c7f4e508.jpg";